module.exports = __webpack_public_path__ + "india.d51ec02e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/flags/india.png
// module id = 1498
// module chunks = 0